import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-help-videos',
  templateUrl: './admin-help-videos.component.html',
  styleUrls: ['./admin-help-videos.component.scss']
})
export class AdminHelpVideosComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
